module.exports = __webpack_public_path__ + "static/img/hiturn.b65b4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hiturn.png
// module id = GbTt
// module chunks = 90